import {TFunction} from 'i18next'

export type Category = {
  value: string
  label: string
  withBudget?: boolean
}

export type Categories = Category[]

export const useHelpCategories = (t: TFunction): Categories => [
  {
    label: t('help_categories_i_need_technical_support'),
    value: 'technical-support',
  },
  {
    label: t('help_categories_i_want_to_suggest_feature'),
    value: 'suggest-feature',
  },
  {
    label: t('help_categories_i_want_to_report_bug'),
    value: 'report-bug',
  },
  {
    label: t('help_categories_i_need_information_about_my'),
    value: 'reimbursement-request',
    withBudget: true,
  },
  {
    label: t('help_categories_i_need_clarification_benefit'),
    value: 'benefit-clarification',
    withBudget: true,
  },
  {
    label: t('Other'),
    value: 'other',
  },
]
